export const USER_ROLE = {
  ADMIN: 'ADMIN',
  PROJECT_MANAGER: 'PROJECT_MANAGER',
  RESEARCHER: 'RESEARCHER',
  COOPERATION_PARTNER: 'COOPERATION_PARTNER',
}
// 권한(역할)별 배지 색 — Projects 헤더, 상단 사용자 드롭다운 등에서 같은 색으로 표시
export const ROLE_BADGE_STYLES: Record<string, { bg: string; text: string }> = {
  [USER_ROLE.PROJECT_MANAGER]: { bg: '#EFF6FF', text: '#1D4ED8' },
  [USER_ROLE.RESEARCHER]: { bg: '#ECFDF5', text: '#065F46' },
  [USER_ROLE.COOPERATION_PARTNER]: { bg: '#FFF7ED', text: '#C2410C' },
  [USER_ROLE.ADMIN]: { bg: '#FEF2F2', text: '#B91C1C' },
}
export const DEFAULT_ROLE_BADGE_STYLE = { bg: '#F3F4F6', text: '#6B7280' }
export const MENU_ID = {
  DASHBOARD: 'DASHBOARD',
  MONITORING: 'MONITORING',
  HOME: 'HOME',
  PROJECT: 'PROJECT',
  EXPLORER: 'EXPLORER',
  WORKSPACE: 'WORKSPACE',
  ABOUT: 'ABOUT',
  GUIDE: 'GUIDE',
  QNA: 'QNA',
  MANAGEMENT: 'MANAGEMENT',
}

export const ERROR_TYPE = {
  // 400
  BAD_REQUEST: { errorCode: 40000, message: 'Invalid input parameters.' },

  ALREADY_EXISTS_ERROR: { errorCode: 40002, message: 'Already exists user ID.' },
  LOST_USER: { errorCode: 40003, message: 'The user does not exist.' },
  AT_LEAST_ONE_ERROR: { errorCode: 40005, message: 'At least one must exist.' },
  NO_PERMISSION: { errorCode: 40006, message: 'Permission Error.' },
  INVALID_CURRENT_PASSWORD: { errorCode: 40013, message: '현재 비밀번호가 일치하지 않습니다.' },
  LOCKED_ACCOUNT_ERROR: { errorCode: 40017, message: '잠긴 계정입니다. 관리자에게 문의하세요.' },

  // 401
  // 토큰 에러
  INVALID_TOKEN_ERROR: { errorCode: 40100, message: 'Invalid token.' },
  EXPIRED_ACCESSTOKEN_ERROR: { errorCode: 40101, message: 'Expired accessToken.' },
  EXPIRED_REFRESH_TOKEN_ERROR: { errorCode: 40102, message: 'Expired refreshToken.' },
  TOKEN_CONFIG_MODIFIED_ERROR: { errorCode: 40103, message: 'Token config has modified.' },
  TOKEN_CREATE_ERROR: { errorCode: 40104, message: 'Failed create token.' },
  LOST_USER_LOGIN: { errorCode: 40105, message: 'Not found Login User.' },
  LICENSE_ERROR: { errorCode: 40106, message: '라이센스 오류.' },
  INVALID_ACCOUNT_ERROR: { errorCode: 40107, message: '잘못된 아이디 또는 비밀번호입니다.' },

  // 404
  NOT_FOUND: { errorCode: 40400, message: 'Not found.' },

  // DB
  DB_QUERY_ERROR: { errorCode: 50010, message: 'DB 오류가 발생 했습니다.' },

  // api helper 에서 통합 처리하지 않고, error data 등을 통해 각 페이지에서 직접 처리
  CUSTOM_ERROR: { errorCode: 50098, message: 'OAuth error' },

  INTERNAL_SERVER_ERROR: { errorCode: 50099, message: 'Server error has occurred.' },
}

// 키워드(태그) 1개의 최대 글자 수. 프로젝트·세션 키워드와 실험노트 태그가 같이 쓴다
// (서버 model.TagNameMaxLength, DB tb_tag.tag_name 길이와 같음)
export const TAG_NAME_MAX_LENGTH = 50

// 키워드·태그·재료를 한 번에 달 수 있는 최대 개수. 프로젝트·세션 키워드, 세션 재료, 실험노트 태그가 같이 쓴다
// (서버 model.TagListMaxCount 와 같음)
export const TAG_LIST_MAX_COUNT = 50

// 실험노트 제목 최대 글자 수 (서버 model.LabNoteTitleMaxLength, DB tb_lab_note.title 길이와 같음)
export const LAB_NOTE_TITLE_MAX_LENGTH = 100

// 재료(물질)명 1개의 최대 글자 수. 세션의 재료 입력과 관리자 재료 관리가 같이 쓴다
// (서버 model.MaterialNameMaxLength, DB tb_material.material_name 길이와 같음)
export const MATERIAL_NAME_MAX_LENGTH = 100
